import {useEffect, useState} from "react";
import PostCard from "../../components/posts/PostCard";
import {Navigate, useSearchParams} from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import Spinner from "../../components/Spinner";
import getUserPost from "../../tools/api/get-user-post/getUserPost";
import {CiImageOff} from "react-icons/ci";
import {BiErrorCircle} from "react-icons/bi";
import useDivarAuth from "../../hooks/useDivarAuth";

const defaultData = {
    IAuth: {
        title: "تأیید هویت ونیفای",
        button: "شروع",
        description: "با افزودن تأییدیه احراز هویت ونیفای، به آگهی خود اعتبار بیشتری ببخشید و اعتماد مشتریان را جلب کنید.",
    },
    BusinessLicenseInquiry: {
        title: "استعلام مجوز کسب‌وکار",
        button: "شروع",
        description: "با افزودن تأییدیه مجوز کسب‌وکار ونیفای، اعتبار آگهی خود را چند برابر کنید و فروش خود را افزایش دهید!",
    },
    PoliceClearance: {
        title: "استعلام سوء‌پیشینه و احراز هویت",
        button: "شروع",
        description: "با افزودن تأییدیه سوء‌پیشینه ونیفای، خیال مشتریان را راحت کنید و سریع‌تر به توافق برسید!",
    },
    TransactionalCredit: {
        title: "استعلام اعتبار معاملاتی",
        button: "شروع",
        description: "با افزودن تأییدیه اعتبار معاملاتی ونیفای، اعتماد به آگهی خود را افزایش دهید و مشتریان بیشتری جذب کنید!",
    },
    CService: {
        title: "گواهی اصالت خودرو",
        button: "شروع",
        description: "با افزودن گواهی اصالت خودرو، به آگهی خود اعتبار ببخشید و خریداران را به سمت خود جذب کنید!",
    },
    Estate: {
        title: "استعلام سند ملکی",
        button: "شروع",
        description: "با افزودن تأییدیه سند ملکی، به آگهی خود ارزش بیشتری دهید و مشتریان بیشتری جذب کنید!",
    },
    OriginalityDevice: {
        title: "تأیید اصالت موبایل و تبلت",
        button: "شروع",
        description: "با افزودن این تأییدیه، به آگهی خود اعتبار بیفزایید و فروش خود را تسریع کنید!",
    },
    CompanyApproval: {
        title: "احراز هویت حقوقی ونیفای",
        button: "شروع",
        description: "با افزودن این تأییدیه، به آگهی خود اعتبار بیفزایید و فروش خود را تسریع کنید!",
    },
    FinCheck: {
        title: "خوش حسابی بانکی",
        button: "شروع",
        description: "با افزودن این تأییدیه، به آگهی خود اعتبار بیفزایید و فروش خود را تسریع کنید!",
    }
};

const DivarPosts = () => {
    const {token}=useDivarAuth();

    const paginationLength = 10;
    const [searchParams] = useSearchParams();
    const serviceType = searchParams.get("serviceType") || "IAuth";
    const data = defaultData[serviceType];
    const [initialPost, setInitialPost] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const [toIndex, setToIndex] = useState(0);

    const [isEmpty,setIsEmpty]=useState(false);
    const [error,setError]=useState(null)
    const handleGetPosts = (data) => {


        setInitialPost(data);
        setHasMore(data.length > paginationLength);
        setToIndex(paginationLength);
        const newPosts = data.slice(0, paginationLength);
        setPosts([...newPosts]);
    };

    useEffect(async () => {
        async function getPosts(){
            const response=await getUserPost(token);

            if(!response.hasError){

                handleGetPosts(response.data.posts)
            }else {
                setIsEmpty(true)
                handleGetPosts([])

                if(response.status===404){
                    setError("آگهی یافت نشد.")
                }else {
                    setError(response.message)
                }

            }
        }
        await getPosts();
    }, []);


    const [posts, setPosts] = useState([]);

    const handleNext = () => {
        setTimeout(() => {
            const newToIndex = toIndex + paginationLength;
            const newPosts = initialPost.slice(toIndex, newToIndex);
            setPosts((prevPosts) => [...prevPosts, ...newPosts]);

            // Update the index and determine if there are more posts to load
            setToIndex(newToIndex);
            setHasMore(newToIndex < initialPost.length);
        }, 200)
    };
    if(!token){
        return  <Navigate to={'/failed'} state={{
            message:'خطای دسترسی'
        }}/>
    }

    return (
        <div className="w-11/12 mt-10 lg:w-8/12 xl:w-4/12  mx-auto">
            <h1 className="w-full text-center mb-1 mt-4  font-bold text-2xl">{data.title}</h1>
            <p className="w-full text-center mb-5  mt-2  px-3">{data.description}</p>
            <div className="w-full py-3 border-t"></div>

            <InfiniteScroll
                dataLength={posts.length} // This is an important field to render the next data
                next={handleNext}
                className="overflow-hidden relative"
                hasMore={hasMore}

                loader={
                    <div className="h-20 w-full flex justify-center items-center">
                        <Spinner className="text-2xl text-green-500"/>
                    </div>
                }

            >
                <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-2">
                    {posts.map((post, index) => {
                        return (
                            <PostCard
                                defaultData={data}
                                serviceType={serviceType}
                                key={index} // Use index as a fallback if post.id is not available
                                post={post}
                            />
                        );
                    })}
                </div>
            </InfiniteScroll>
            {isEmpty && <div className="w-full p-5 flex flex-col justify-center rounded-lg items-center bg-white text-center text-gray-800">

                <BiErrorCircle className="text-3xl mb-2"/>
                <span className="text-semibold text-lg">{error}</span>
            </div>}
        </div>
    );
};

export default DivarPosts;